





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Constants from '@/services/constants';
import { Farm } from '@/interfaces/farm';
import { Parcel } from '@/interfaces/parcel';
import { getParcelStatus, getParcelCycle, getParcelCropStageAsString } from '@/services/analyticData';
import { getLocalizedDate, stringToMomentDate } from '@/services/date';

@Component({
  filters: {
    date(value: string) {
      return getLocalizedDate(value);
    }
  }
})
export default class GeneralInfoDefault extends Vue {
  @Prop() hasAnalytic: boolean;
  @Prop() selectedFarm: Farm | null;

  get showNumberOfCycles(): boolean {
    return !Constants.indiaCountryIds.includes(this.$store.state.selectedCountry?.id);
  }

  get parcelArea(): number {
    return Math.round(this.$store.state.analytic.selectedParcel.Area / 100) / 100;
  }

  getStatus(parcel: Parcel): string {
    return getParcelStatus(
      parcel,
      this.$store.state.analytic.fromTo.to,
      this.$root.$i18n,
      this.$store.state.selectedCountry
    );
  }

  getAge(parcel: Parcel): string {
    if (!parcel.Planted) return '-';
    const planted = stringToMomentDate(parcel.Planted).startOf('day');
    const selectedDate = this.$store.state.analytic.selectedSurvey
      ? this.$store.state.analytic.selectedSurvey.Date
      : this.$store.state.analytic.fromTo.to;
    const reference = stringToMomentDate(selectedDate).startOf('day');
    const totalDays = reference.diff(planted, 'days');
    if (totalDays < 0) return '-';
    if (totalDays < 30) return `${totalDays} day${totalDays === 1 ? '' : 's'}`;
    const months = reference.diff(planted, 'months');
    const remainingDays = reference.diff(planted.clone().add(months, 'months'), 'days');
    const monthPart = `${months} month${months === 1 ? '' : 's'}`;
    return remainingDays > 0 ? `${monthPart} ${remainingDays} day${remainingDays === 1 ? '' : 's'}` : monthPart;
  }

  getCycle(parcel: Parcel): number {
    return getParcelCycle(parcel, this.$store.state.analytic.fromTo.to);
  }

  getCropStage(parcel: Parcel): string {
    return getParcelCropStageAsString(parcel, this.$store.state.analytic.fromTo.to, this.$root.$i18n);
  }
}
